import { render, staticRenderFns } from "./CenterViewFirstTimeFreeTop_Ap.vue?vue&type=template&id=0f4e5bf3&scoped=true"
import script from "./CenterViewFirstTimeFreeTop_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewFirstTimeFreeTop_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewFirstTimeFreeTop_Ap.vue?vue&type=style&index=0&id=0f4e5bf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e5bf3",
  null
  
)

export default component.exports